import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import ClientsDropDown from "./ClientsDropDown";
import UsersDropDown from "./UsersDropDown";
import OrderDropDown from "./SubscriptionDropDown";
import Classes from "./AddOrder.module.css";
import SubscriptionOrderDropDown from "./SubscriptionDropDown";

const LeftArrow = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
)

export default function AddOrder() {
    const navigateTo = useNavigate();
    const [selectedClient, setselectedClient] = useState(null);
    const [title, setTitle] = useState("");
    const [amount, setAmount] = useState("");
    const [dateAdded, setdateAdded] = useState("");
    const [dateStarted, setdateStarted] = useState("");
    const [dateDue, setdateDue] = useState("");
    const [dateCompleted, setdateCompleted] = useState("");

    const clients = [
        { id: 1, name: "John Smith", email: "johnsmith@gmail.com" },
        { id: 2, name: "Jane Doe", email: "janedoe@gmail.com" }
    ];

    const subs = ["No Subscriptions", "Subscription 1", "Subscription 2", "Subscription 3"];

    const handleBackClick = () => navigateTo("/orders");

    // Form Submit Handler
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", {
        });
    };

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <button onClick={handleBackClick} className={Classes.backButton}>
                    <LeftArrow height='13px' fill='#969696' />
                    <h5>Orders</h5>
                </button>
            </div>
            <div className={Classes.hero2}>
                <h3>Add order</h3>

                <form onSubmit={handleSubmit}>
                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Title</label>
                        <input
                            type="text"
                            className={Classes.inputField}
                            placeholder="Enter title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Date added</label>
                            <input
                                type="date"
                                className={Classes.inputField}
                                placeholder="MM/DD/YYYY"
                                value={dateAdded}
                                onChange={(e) => setdateAdded(e.target.value)}
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Date started</label>
                            <input
                                type="date"
                                className={Classes.inputField}
                                placeholder="MM/DD/YYYY"
                                value={dateStarted}
                                onChange={(e) => setdateStarted(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={Classes.flexColGroup} >
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Date due</label>
                            <input
                                type="date"
                                className={Classes.inputField}
                                placeholder="MM/DD/YYYY"
                                value={dateDue}
                                onChange={(e) => setdateDue(e.target.value)}
                            />
                        </div>
                        <div className={Classes.flexCol1}>
                            <label className={Classes.label}>Date completed</label>
                            <input
                                type="date"
                                className={Classes.inputField}
                                placeholder="MM/DD/YYYY"
                                value={dateCompleted}
                                onChange={(e) => setdateCompleted(e.target.value)}
                            />
                        </div>
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Client</label>
                        <ClientsDropDown
                            clients={clients}
                            selectedClient={selectedClient}
                            setselectedClient={setselectedClient}
                        />
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Subscription</label>
                        <SubscriptionOrderDropDown
                            value={subs}
                        />
                    </div>

                    <div className={Classes.flexCol1}>
                        <label className={Classes.label}>Amount</label>
                        <input
                            type="number"
                            className={Classes.inputField}
                            placeholder="$0.00"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                        />
                    </div>

                    <div className={Classes.flexEnd}>
                        <button type="submit" className={Classes.submitBtn}>
                            <h5>Add order</h5>
                        </button>
                    </div>
                </form>
            </div>
        </div >
    );
}
